// extracted by mini-css-extract-plugin
export var divider = "_db-7";
export var itemsToggle = "_db-8";
export var mergeModal = "_db-1";
export var optionCard = "_db-4";
export var radioGroup = "_db-6";
export var radioOption = "_db-0";
export var selected = "_db-5";
export var shipmentOptions = "_db-2";
export var tableOptions = "_db-3";